import {
	getMode,
	isConfluenceMacro,
	isEmbed,
	isReportMode,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app/index.tsx';
import { getExportAppWidth } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/section-widths/index.tsx';
import { getViewMode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/view-settings/index.tsx';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types.tsx';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect/index.tsx';
import type { StateProps } from './types.tsx';

export default createStructuredSelector<State, StateProps>({
	mode: getMode,
	viewMode: getViewMode,
	exportAppWidth: getExportAppWidth,
	isReportMode,
	isConfluenceMacro,
	isEmbed,
});
